export enum TeamsRoles {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    ACM = 'acm',
    JEM = 'jem',
    YOUTH_RIDER = 'youthRider',
    ADULT_RIDER = 'adultRider',
  }
